import { useEffect } from "react"
import { getpervStateTab } from "../../../redux/loansTab/loansTabSlice";
import { IFormInnerState } from "../../requestSteps/form/IFormInnerState";
import Guarantor from "../../requestSteps/guarantors/guarantor";
import GuarantorCompletion from "../../requestSteps/guarantors/guarantorCompletion";
import GuarantorInfo from "../../requestSteps/guarantors/guarantorInfo";
import GuarantorRegister from "../../requestSteps/guarantors/guarantorRegister";
import { TGuarantorContainer } from "./TGuarantorContainer";
import { changeRouteType } from "../../../redux/handleBackBtn/handleBackBtnSlice";
import GuarantorOtp from "../../requestSteps/guarantors/otp/guarantorOtp";
import GuarantorInquiryResult from "../../requestSteps/guarantors/result/guarantorInquiryResult";
import InquiryOtp from "../../requestSteps/inquiryFee/otp/inquiryOtp";
import InquiryResult from "../../requestSteps/inquiryFee/result/inquiryResult";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";

export default function GuarantorContainer({ setFormInnerState, setStep, referenceKey }: IFormInnerState) {
    const navigate = useNavigate();
    const setInnerState = (state: TGuarantorContainer) => navigate(`/loans/request/Guarantors/${state === 'guarantorIntroduce' ? '' : state}`);
    // let stateRedux: TGuarantorContainer;
    // //  = 'guarantorIntroduce';
    // stateRedux = useSelector((state: RootState) => state.loansTabComponents.prevState) as TGuarantorContainer;
    // if (stateRedux.includes('appContainer')) {
    //     stateRedux = 'guarantorIntroduce'
    // } else {
    //     stateRedux = stateRedux;
    // }
    return (
        <div>
            <Routes>
                <Route index element={<Guarantor referenceKey={referenceKey} setInnerState={setInnerState} setStep={setStep} />} />
                <Route path="guarantorCompletion" element={<GuarantorCompletion setInnerState={setInnerState} setStep={setStep} referenceKey={referenceKey} />} />
                <Route path="guarantorInfo" element={<GuarantorInfo referenceKey={referenceKey} setInnerState={setInnerState} setStep={setStep} />} />
                <Route path="guarantorRegister" element={<GuarantorRegister referenceKey={referenceKey} setInnerState={setInnerState} setStep={setStep} />} />
                <Route path="otp" element={<GuarantorOtp setInnerState={setInnerState} referenceKey={referenceKey} />} />
                <Route path="guarantorInquiryResult" element={<GuarantorInquiryResult referenceKey={referenceKey} setStep={setStep} setInnerState={setInnerState} />} />
                <Route path="*" element={<Navigate to="/loans/request/Guarantors" replace />} />
            </Routes>
        </div>
    )
}
